import { RootState } from '../..';
import { IMapWaterSystemsMetrics } from '../../../types';
  
const loading = (state: RootState) => state.mapWaterSystemMetrics.loading

export const selectMapWaterSystemsData = (state: RootState): IMapWaterSystemsMetrics => 
  state.mapWaterSystemMetrics.data ?? [];

export const MapWaterSystemsMetricsSelector = {
  selectMapWaterSystemsData,
  loading,
};